<template>
  <div class="container">
    <div class="faq-header">
      <div class="faq-header-head">
        <h1 class="entry-title" v-text="$t('route.faq')" />
      </div>
      <div class="faq-header-breadcrumbs">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }" v-text="$t('route.home')" />
            </li>
            <li class="breadcrumb-item active" aria-current="page" v-text="$t('route.faq')"></li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="faq-main">
      <div class="d-flex flex-wrap">
        <div class="col-12 col-sm-8 col-md-8">
          <div class="panel-group">
            <div
              class="panel panel-default"
              data-toggle="collapse"
              data-target="#whatIsTLC"
              aria-expanded="true"
              aria-controls="whatIsTLC"
              id="whatIsTLCHead"
            >
              <h4>
                <span class="fa"></span>What is TrueLifeCare.org?
              </h4>
            </div>

            <div
              class="panel-collapse collapse show"
              id="whatIsTLC"
              aria-labelledby="whatIsTLCHead"
              data-parent="#accordionExample"
            >
              <div class="panel-body">
                <p>TrueLifeCare.org is a video-based website that allows a church member to freely access high-quality Christian content on most every counseling issue. TLC contains a robust film database with topics pertaining to infidelity, alcoholism, forgiveness, and many others. These films can be used by pastors, lay counselors, discipleship programs, and individually by the church member.</p>
              </div>
            </div>
          </div>

          <div class="panel-group">
            <div
              class="panel panel-default"
              data-toggle="collapse"
              data-target="#whatTLCDo"
              aria-expanded="false"
              aria-controls="whatTLCDo"
              id="whatTLCDoHead"
            >
              <h4>
                <span class="fa"></span> What does the website do? What was it built for?
              </h4>
            </div>

            <div
              class="panel-collapse collapse"
              id="whatTLCDo"
              aria-labelledby="whatTLCDoHead"
              data-parent="#accordionExample"
            >
              <div class="panel-body">
                <p>The primary focus of TrueLifeCare.org is to offer preventative care to partnering churches by providing anonymous access to a robust library of counseling videos and articles. To access the content, the church member will log in to TLC using the username and password that is provided in the church bulletin and/or on the projector. There is no limit to the number of times the member logs in or how many videos are watched.</p>
              </div>
            </div>
          </div>

          <div class="panel-group">
            <div
              class="panel panel-default"
              data-toggle="collapse"
              data-target="#whoIsTL"
              aria-expanded="false"
              aria-controls="whoIsTL"
              id="whoIsTLHead"
            >
              <h4>
                <span class="fa"></span>Who is TrueLife.org?
              </h4>
            </div>

            <div
              class="panel-collapse collapse"
              aria-labelledby="whoIsTLHead"
              id="whoIsTL"
              data-parent="#accordionExample"
            >
              <div class="panel-body">
                <p>Is a unique non-profit Christian organization dedicated to showing the world that the Bible is true and reliable. TrueLife desires to spread the gospel of Jesus Christ effectively and lead people to a Bible-teaching church in their area. TrueLife uses online videos and other media, local conferences and evangelistic events to bring individuals to faith in Christ.</p>
              </div>
            </div>
          </div>

          <div class="panel-group">
            <div
              class="panel panel-default"
              data-toggle="collapse"
              data-target="#whoIsAAOCC"
              aria-expanded="false"
              aria-controls="whoIsAAOCC"
              id="whoIsAAOCCHead"
            >
              <h4>
                <span class="fa"></span>Who is the America Association of Christian Counselors?
              </h4>
            </div>

            <div
              class="panel-collapse collapse"
              aria-labelledby="whoIsAAOCCHead"
              id="whoIsAAOCC"
              data-parent="#accordionExample"
            >
              <div class="panel-body">
                <p>We are committed to helping the church equip God’s people to love and care for each other in the same spirit that Christ loves and cares for us. We recognize Christian counseling as a unique and case-based form of Christian discipleship, assisting the church in its call to bring believers to maturity in the lifelong process of sanctification- of growing to maturity in Christ.</p>
                <p>We recognize that some are gifted to do so in the context of a clinical, professional and/or pastoral manner. We also believe that selected lay people are gifted to care for others and that they need the appropriate training and mentoring to do so. We believe that the ‘seat’ of helping ministry in the church is supported—must be supported—by three strong legs. These legs are the pastor, the lay helper, and the clinical professional, and it is to these three roles that AACC is dedicated to serve.</p>
                <p>
                  It was He who gave some to be apostles, some to be prophets, some to be evangelists, and some to be pastors and teachers, to prepare God’s people for works of service, so that the body of Christ may be built up until we all reach unity in the faith and in the knowledge of the Son of God and become mature, attaining to the whole measure of the fullness of Christ.
                  <br />Ephesians 4:11-13
                </p>
                <p></p>
              </div>
            </div>
          </div>

          <div class="panel-group">
            <div
              class="panel panel-default"
              data-toggle="collapse"
              data-target="#membershipTLC"
              aria-expanded="false"
              aria-controls="membershipTLC"
              id="membershipTLCHead"
            >
              <h4>
                <span class="fa"></span>How does a church cancel it's membership to TLC?
              </h4>
            </div>

            <div
              class="panel-collapse collapse"
              aria-labelledby="membershipTLCHead"
              id="membershipTLC"
              data-parent="#accordionExample"
            >
              <div class="panel-body">
                <p>To cancel, the pastor must call to speak to a TrueLifeCare representative. If the church is a yearly subscriber, the pastor must call to cancel the account before the next year’s enrollment date. If the church is a monthly subscriber, the pastor may call in to cancel the account at any time before the next month’s payment. Once the account is canceled, the church members will no longer have access to the content on the site.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md-4">
          <div class="textwidget">
            <p>Still have questions? Use the form below to send us your questions and we’ll do our best to answer them.</p>
            <form id="faq">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-6">
                  <input name="firstName" placeholder="First Name" />
                </div>
                <div class="col-12 col-sm-6 col-md-6">
                  <input name="lastName" placeholder="Last Name" />
                </div>
              </div>
              <div class="row">
                <input name="email" placeholder="Email Address" />
              </div>
              <div class="row">
                <textarea
                  name="input_3"
                  class="textarea medium"
                  placeholder="Your Question(s)"
                  rows="5"
                />
              </div>

              <div class="button">
                <a href="javascript:void(0)" @click.prevent="submitQuestion">SEND</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq',
  methods: {
    submitQuestion() {
      const dataInput = $('#faq')
        .serializeArray()
        .reduce(function(obj, item) {
          obj[item.name] = item.value
          return obj
        }, {})
    }
  }
}
</script>
<style lang="scss">
.faq-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &-head {
    color: #2ba349;
    .entry-title {
      font-size: 52px;
      line-height: 62px;
    }
  }
  &-breadcrumbs {
    .breadcrumb {
      font-weight: 300;
      color: #adb0b6;
      font-size: 13px;
      line-height: 25px;
      text-transform: none;
      background-color: transparent;
      padding: 3px 12px 2px 12px;
      margin: 0;
      &-item {
        &.active,
        &::before {
          color: #adb0b6;
        }
      }
      a {
        color: #adb0b6;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
.faq-main {
  padding: 70px 0;
  color: #787d85;
  font-weight: 300;
  .panel-group {
    .panel-default {
      cursor: pointer;
      h4 {
        color: #3b3f4a;
        margin-bottom: 10px;
        font-size: 20px;
        line-height: 30px;
        font-weight: 600;
        span {
          color: #bababa;
          font-size: 14px;
          margin-right: 10px;
        }
      }
    }
    .panel-body {
      padding-left: 20px;
      margin-bottom: 10px;
      p {
        font-size: 14px;
        line-height: 28px;
      }
    }
  }

  [data-toggle='collapse'][aria-expanded='true'] .fa:before {
    content: '\f068';
  }

  [data-toggle='collapse'] .fa:before {
    content: '\f067';
  }
  .col-12,
  .col-sm-8,
  .col-md-8,
  .col-sm-4,
  .col-md-4 {
    padding: 0;
  }

  .textwidget {
    > p {
      font-size: 14px;
      line-height: 28px;
      margin-bottom: 50px;
    }
    form {
      .row {
        padding: 0;
        margin: 0;
      }
      input,
      textarea {
        width: 100%;
        resize: none;
        color: #787d85;
        border-width: 1px;
        border-color: rgba(173, 176, 182, 0.3);
        background-color: #fff;
        border-radius: 1px;
        padding-left: 5px;
        font-weight: 300;
        &::placeholder {
          font-size: 14px;
          color: #bfb9d1;
        }
      }

      .row {
        margin-top: 20px;
        > div {
          padding-right: 16px;
        }
        &:nth-child(1) {
          margin-bottom: 30px;
        }
      }
    }

    .button {
      text-align: left;
      padding-top: 50px;
      a {
        color: #fff;
        font-size: 14px;
        line-height: 16px;
        font-weight: 500;
        padding: 10px 16px;
        border-radius: 2px;
        background-color: #6ab165;
      }
    }
  }
}
</style>
